export interface IFaq {
  question: string;
  answer: string;
}
export interface FaqAccordionNoscriptProps {
  faqs: IFaq[];
  title?: string;
}

const FaqAccordionNoscript = ({ faqs, title = '' }: FaqAccordionNoscriptProps) => {
  return (
    <noscript>
      <div>
        <h2>{title}</h2>
        {faqs?.map((faq) => (
          <div>
            <h3>{faq.question}</h3>
            <p>{faq.answer}</p>
          </div>
        ))}
      </div>
    </noscript>
  );
};

export default FaqAccordionNoscript;
